import { TThunkAction } from '../../types/redux';
import { selectCurrentPage } from '../../selectors/pagination';
import { paginationFailure, paginationRequest, paginationSuccess } from './actions';
import { getObjectInfo } from '../../selectors/objectInfo';
import { getActiveRatingFilters, getActiveTagFilters } from '../../selectors/filters';
import { fetchReviews } from '../../services/reviews';
import { setReviewsPagination } from '../reviews';
import { setAnswers } from '../answers';
import { getActiveSortValue } from '../../selectors/sort';
import { prepareTagsFiltersRequest, prepareTagsFiltersStore } from '../../mappers/prepareTagsFilters';
import { prepareSortRequest } from '../../mappers/prepareSort/prepareSortRequest';
import { setRatingFilters, setTagFilters } from '../filters';

export const reviewsPaginationRequestAction =
  (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
    const { logger, httpApi } = context;
    const state = getState();

    const { objectId } = getObjectInfo(state);
    const ratingFilters = getActiveRatingFilters(state);
    const tagFilter = getActiveTagFilters(state);
    const sort = getActiveSortValue(state);
    const page = selectCurrentPage(state);

    const nextPage = page + 1;

    try {
      dispatch(paginationRequest());

      const { answers, reviews, hasMore, page, availableFilters, tags } = await fetchReviews({
        httpApi,
        parameters: {
          newbuildingId: objectId,
          filters: ratingFilters,
          page: nextPage,
          tag: prepareTagsFiltersRequest(tagFilter),
          sort: prepareSortRequest(sort),
        },
      });

      dispatch(setRatingFilters(availableFilters));
      dispatch(setTagFilters(prepareTagsFiltersStore(tags)));
      dispatch(paginationSuccess());
      dispatch(setAnswers(answers));
      dispatch(
        setReviewsPagination({
          ...reviews,
          hasMore,
          page: page || 0,
        }),
      );
    } catch (error) {
      dispatch(paginationFailure());
      logger.error(error, {
        domain: 'reviews#pagination',
        message: error.message,
      });
    }
  };
